import type { SpendClassification } from '@app/src/wf-constants'
import type ReactEChartsCore from 'echarts-for-react/lib/core'
import type React from 'react'
import { createContext, useContext } from 'react'
import type { SummaryChartDataTypes } from './Charts/PeriodChartsConfigs/usePeriodSummaryChartConfigs'

export type ModalStatistics = { id: number; title: string; resultForGroups: { groupName: string }[] }
export type UserSelection = {
  answer?: string[]
  summaryType?: SummaryChartDataTypes[]
  groupBy?: string
  groupName?: string
  groupId?: string
  periodNames?: string[]
  spendClassifications?: SpendClassification[]
}

export type DataInsightsModalContextProps = {
  openDataInsightsModal: (statistics: ModalStatistics, userSelection?: UserSelection) => void
  statistics?: ModalStatistics
  setStatistics: React.Dispatch<React.SetStateAction<ModalStatistics | undefined>>
  userSelection?: UserSelection
  setUserSelection: React.Dispatch<React.SetStateAction<UserSelection | undefined>>
  periodNames?: string[] | undefined
  formattedPeriods?: string
  spendClassifications?: SpendClassification[] | undefined
  groupId?: string
  formattedNonPeriodGroupNames?: string
  echartsRefs: React.MutableRefObject<ReactEChartsCore | null>[]
  setDataInsightsRefForIndex(ref: React.MutableRefObject<ReactEChartsCore | null>, index: number): void
  clearEchartsRefOverIndex(index: number): void
}

export const DataInsightsModalContext = createContext<DataInsightsModalContextProps>({
  openDataInsightsModal: () => undefined,
  setStatistics: () => undefined,
  setUserSelection: () => undefined,
  echartsRefs: [],
  setDataInsightsRefForIndex: () => undefined,
  clearEchartsRefOverIndex: () => undefined,
})

export const useDataInsightsModal = (): DataInsightsModalContextProps => {
  return useContext(DataInsightsModalContext)
}
